import React from 'react'
import PropTypes from 'prop-types'

import styles from './common-frame.scss'
import cn from 'classnames'

const CommonFrame = props => {
  const { actionLayer, descLayer, mobileFullScreen } = props
  return (
    <main className={cn(styles['common-frame-container'], { [styles['mobile-full-screen']]: mobileFullScreen })}>
      <section className={styles['action-container']}>{actionLayer}</section>
      <section className={styles['desc-container']}>{descLayer}</section>
    </main>
  )
}

CommonFrame.propTypes = {
  actionLayer: PropTypes.element,
  descLayer: PropTypes.element,
  mobileFullScreen: PropTypes.bool
}

export default CommonFrame
